import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import {
  Alert,
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Space,
  Typography,
} from 'antd'
import SBPhoneInput from '../../../../modules/sb-antd-phone-input/SBPhoneInput'
import { emailRule, isE164Phone, requiredRule } from '../../../../utils/rules'

const { Text } = Typography

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  let companyContacts = form.getFieldError('contacts')
  const contacts = Form.useWatch('contacts', form) || []

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="name" rules={[requiredRule()]} label={'Name'} required>
        <Input />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {() => (
          <Alert
            title={contacts.length === 0 ? 'Attention' : 'Information'}
            description={
              contacts.length === 0
                ? 'You must add at least one company contact.'
                : 'An email will be sent to these contacts with an invitation to access and join the secondary back office platform.'
            }
            type={contacts.length === 0 ? 'error' : 'info'}
            showIcon
          />
        )}
      </Form.Item>

      <Form.List
        name="contacts"
        rules={[
          {
            validator: async (_, value) => {
              if (!value || value.length === 0) {
                return Promise.reject(
                  new Error('You must add at least one company contact')
                )
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space
                key={key}
                style={{ display: 'flex', marginBottom: 8, marginTop: 40 }}
                orientation="vertical"
              >
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'first_name']}
                      rules={[requiredRule()]}
                      label="Contact First Name"
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'last_name']}
                      rules={[requiredRule()]}
                      label="Contact Last Name"
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'email']}
                      rules={[requiredRule(), emailRule()]}
                      label="Contact Email"
                    >
                      <Input className="authField" autoComplete="email" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'phone']}
                      rules={[isE164Phone()]}
                      label="Contact Phone"
                    >
                      <SBPhoneInput enableSearch />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      {...restField}
                      name={[name, 'position']}
                      rules={[requiredRule()]}
                      label="Contact Position"
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <DeleteOutlined
                    onClick={() => remove(name)}
                    style={{ color: 'red', fontSize: 20 }}
                  />
                </Row>

                <Divider />
              </Space>
            ))}

            <Form.Item
              required
              rules={[requiredRule()]}
              style={{ marginTop: 40 }}
            >
              <Button
                variant={companyContacts.length !== 0 ? 'outlined' : 'dashed'}
                color={companyContacts.length !== 0 ? 'danger' : 'default'}
                onClick={() => (add(), (companyContacts = []))}
                block
                icon={<PlusOutlined />}
              >
                Add a company contacts
              </Button>
              {companyContacts.length !== 0 && (
                <Text type="danger">{companyContacts}</Text>
              )}
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  )
}

export default Create
